import { each } from "fxjs/es";
import { ControllerNS } from "../../Controller/ControllerNS.js";
import { VONS } from "../../VO/VONS.js";
import { TargetPointView } from "./TargetPointView.js";
export class CommandMView {
  constructor({ command_m_controller, target_point_view }) {
    this._command_m_controller = command_m_controller;
    this._target_point_view = target_point_view;
    command_m_controller.subscribe((vo) => this._observeCommandMController(vo));
  }
  appendTo({ point_container_el }) {
    point_container_el.appendChild(this._target_point_view.getEl());
  }
  remove() {
    const target_point_el = this._target_point_view.getEl();
    target_point_el.parentNode?.removeChild(target_point_el);
  }
  insertNodesBeforeSelf(points) {
    const target_point_el = this._target_point_view.getEl();
    const point_container_el = target_point_el.parentElement;
    if (point_container_el != null) {
      each((point) => point_container_el.insertBefore(point, target_point_el))(
        points
      );
    }
  }
  click(node) {
    if (this._target_point_view.getEl().contains(node)) {
      this._command_m_controller.click({
        point: "target",
      });
      return;
    }
    this._command_m_controller.click({
      point: null,
    });
  }
  _observeCommandMController({ target_point }) {
    this._target_point_view.setPosition({
      x: target_point.x,
      y: target_point.y,
    });
    target_point.is_show
      ? this._target_point_view.show()
      : this._target_point_view.hide();
    target_point.is_selected
      ? this._target_point_view.select()
      : this._target_point_view.unselect();
  }
}
